var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default"),_vm._v(" "),_c('input',{attrs:{"type":"file","multiple":"","accept":"image/*"},on:{"change":function($event){return _vm.detectFiles($event.target.files)}}}),_vm._v(_vm._s(_vm.progressUpload)+"%\n")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5396d7ee","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/FileUploader.vue
// module id = 116
// module chunks = 0